module.exports = __webpack_public_path__ + "static/media/sacolaG.2d59c46a.svg";